import HandshakeIcon from 'assets/images/composition/handshake-with-yellow-heart.webp';
import {Modal} from 'letrus-ui';
import styles from './DesktopStoreRatingModal.module.scss';

function DesktopStoreRatingModal(): JSX.Element {
  return (
    <Modal id="desktopStoreRatingModal" className={styles.modal} closeButton>
      <div className={styles.container}>
        <h3>Ajude-nos a crescer com a sua opinião!</h3>

        <p>
          Se você também usa a Letrus no seu celular, queremos saber o que acha!
          Sua avaliação na Play Store ou Apple Store ajuda a gente a melhorar o
          app e também faz com que mais estudantes descubram a Letrus.
        </p>

        <img src={HandshakeIcon} alt="Nos avalie na loja de aplicativos" />

        <b>
          É só abrir a Apple ou Play Store no seu celular e buscar por
          &ldquo;Letrus&rdquo; para avaliar!
        </b>

        <p>Valeu pelo apoio! ❤️</p>
      </div>
    </Modal>
  );
}

export default DesktopStoreRatingModal;
